import api from './api';

const sanitizeLaudoFileName = rawFileName => {
  const name = String(rawFileName || '')
    .split('/')
    .pop();
  if (!name) return '';

  return name
    .replaceAll(' ', '')
    .replaceAll('%20', '')
    .replaceAll('%2520', '');
};

const requestLaudoPresignDownload = (params, config = {}) =>
  api.get('/files/laudos/presign', { params, ...config });

const requestLaudoPresignUpload = ({ procedimento, codLaudo, fileName }) =>
  api.post('/files/laudos/presign', {
    procedimento,
    codLaudo,
    fileName: sanitizeLaudoFileName(fileName),
  });

const uploadBlobToLaudo = async ({
  procedimento,
  codLaudo,
  fileName,
  body,
  contentType,
}) => {
  const { data } = await requestLaudoPresignUpload({
    procedimento,
    codLaudo,
    fileName,
  });

  const uploadContentType = data.contentType || contentType;
  if (!uploadContentType) {
    throw new Error('Content-Type não definido para upload');
  }

  const uploadResponse = await fetch(data.preSignedUrl, {
    method: 'PUT',
    body,
    headers: { 'Content-Type': uploadContentType },
  });

  if (!uploadResponse.ok) {
    // TODO: sentry para monitorar!
    throw new Error('Erro ao enviar arquivo para o armazenamento!');
  }

  return data;
};

export {
  sanitizeLaudoFileName,
  requestLaudoPresignDownload,
  requestLaudoPresignUpload,
  uploadBlobToLaudo,
};
